import React, { FC, useMemo } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Benefits from '~/modules/feature-access/components/Benefits';
import HumanizerGoalAnimation from '~/modules/feature-access/components/HumanizerGoalAnimation';
import { getBenefitsList } from '~/modules/feature-access/helpers';
import { FeatureKey, FeatureModule } from '~/modules/feature-access/policy';
import { HUMANIZER_MODE_V2 } from '~/modules/tools/views/AiHumanizerV4/constants';
import projectConfig from '~/projects/config';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  humanizerMode?: HUMANIZER_MODE_V2;
};

const HumanizerGoal: FC<Props> = ({ humanizerMode }) => {
  const { t } = useTranslation();

  const benefits = useMemo(() => {
    return getBenefitsList(t)
      .filter(
        (el) =>
          !(
            el.key === FeatureKey.HUMANIZER_GOAL &&
            el.module === FeatureModule.AI_TEXT_HUMANIZER
          ),
      )
      .sort(
        (a, b) =>
          Number(b.module === FeatureModule.AI_TEXT_HUMANIZER) -
          Number(a.module === FeatureModule.AI_TEXT_HUMANIZER),
      );
  }, []);

  return (
    <div className={styles.container}>
      <Typography
        variant={Typographies.TITLE_LARGE}
        component="div"
        className={styles.title}
      >
        {t('modal:feature_unlock.humanizer_goal_title', {
          project: projectConfig.getProjectName(),
          defaultValue:
            'Upgrade to {{project}} Unlimited To Set Humanization Goal',
        })}
      </Typography>

      <div className={styles.animation}>
        <HumanizerGoalAnimation humanizerMode={humanizerMode} />
      </div>

      <Benefits benefits={benefits} />
    </div>
  );
};

export default HumanizerGoal;
